module.exports = __webpack_public_path__ + "static/media/tag.a9604bfb.svg";